import Vue from 'vue'
import Router from 'vue-router'
import Intro from '../components/Intro.vue'
import Home from '../components/Home.vue'
import About from '../components/About.vue'
import Works from '../components/Works.vue'
import Whatido from '../components/Whatido.vue'
import Contact from '../components/Contact.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',  // 해쉬값 제거
  routes: [
    {
      path: '/',                  
      component: Intro     
    },
    {
      path: '/home',
      component: Home
    }, 
    {
      path: '/about',
      component: About
    }, 
    {
      path: '/works',
      component: Works
    },
    {
      path: '/whatido',
      component: Whatido
    },
    {
      path: '/contact',
      component: Contact
    },
  ]
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js